import { render, staticRenderFns } from "./AutoCompleteField.vue?vue&type=template&id=4512c0c4"
import script from "./AutoCompleteField.vue?vue&type=script&lang=ts"
export * from "./AutoCompleteField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports